import React from "react";
import { Link, Redirect } from "react-router-dom";
import { useStore } from "react-redux";
import styled from "styled-components";

const StyledLink = styled(Link)`
  text-decoration: ${(props) => props.textDecoration || "none"};
`;

export default function LinkWithQuery({
  disabled = false,
  children,
  to,
  search,
  ...props
}) {
  const store = useStore();
  const accountId = store
    .getState()
    .getIn(["headers", "profile", "payclaim_account_id"]);
  const defaultSearch = "?account_id=" + accountId;
  const pathname = typeof to === "string" ? to : to.pathname;
  return (
    <StyledLink
      to={{
        pathname: pathname,
        search: search || defaultSearch,
        ...to,
      }}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
      {...props}
    >
      {children}
    </StyledLink>
  );
}

export function RedirectWithQuery({ children, to, search, ...props }) {
  const store = useStore();
  const accountId = store
    .getState()
    .getIn(["headers", "profile", "payclaim_account_id"]);
  const defaultSearch = "?account_id=" + accountId;

  return (
    <Redirect
      to={{
        pathname: to,
        search: search || defaultSearch,
      }}
      {...props}
    >
      {children}
    </Redirect>
  );
}
